export default __webpack_public_path__ + "static/media/vr.3bb4d04f.svg";